import { configureStore } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import promiseMiddleware from 'redux-promise-middleware';

import loggerMiddleware, { summarizeReduxAction } from './logger-middleware';

import { resolver } from '@mse-reg/clients';
import { rootReducer } from './root-reducer';

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  // Registration payloads can be large and contain personal data. Keep request
  // diagnostics, but do not retain complete Redux actions or state snapshots.
  attachReduxState: false,
  stateTransformer: () => null,
  actionTransformer: summarizeReduxAction,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: {
        extraArgument: {
          resolver, // Rep lace with your actual resolver instance
        },
      },
      immutableCheck: {
        // Registration responses contain large, deeply nested server snapshots.
        // Immer still protects reducer updates; skipping this server-owned subtree
        // prevents the development-only invariant middleware from blocking the UI
        // for hundreds of milliseconds on every action.
        ignoredPaths: ['moduleRegistration.moduleRegistrationInfo', 'uasRegistration.registrations'],
      },
      serializableCheck: false,
    }).concat(promiseMiddleware, loggerMiddleware),
  enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(sentryReduxEnhancer),
});
